import { useErrorMessageId } from "src/utilities/errorScrolling"

export type ErrorMessageProps = {
  message: string | null | undefined
}

export const NpErrorMessage = ({ message }: ErrorMessageProps) => {
  const errorId = useErrorMessageId()

  return (
    <div
      id={errorId}
      className="text-np-error w-full text-pretty"
      dangerouslySetInnerHTML={{ __html: message || "" }}
    />
  )
}
